;(function($, window, document) {
    
    $(document).ready(function(){
       
       if (typeof $.fn.slick == 'function') {

            $('.icon-popup-slider').slick({
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                infinite: true,
                mobileFirst: true,
                responsive: [
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                      }
                    },
                    {
                        breakpoint: 1023,
                        settings: "unslick",
                    }
                ]
            });
           
       }
       
    });
    
    $(window).on('resize orientationchange', function() {
        
        if (typeof $.fn.slick == 'function') {
            $('.icon-popup-slider').slick('resize');
        }

    });
    
})(jQuery, window, document);